import React from 'react';
import Main from '../components/Main';
import { Wrap } from '../components/styled';
import { ContentTwoModal, getTextMessageTwoModal } from './ContentTwoModal';
import MessagePlate from '../components/MessagePlate';
import { useMunicipalityTasks } from '../MunicipalityTasksContext';
import RequestReportPlate from '../components/RequestReportPlate';
import { getTextPlate } from '../getText';

export const SafeTerritory = () => {
  const { values, id, userType } = useMunicipalityTasks();
  const { plate1, plate2, plate3, plate4 } = values;
  const isDone = plate1?.status! && plate2?.status! && plate3?.status! && plate4?.status!;
 
  const textPlate2 = getTextPlate({ count: plate2?.count || 0, userType });
  const utm = `&cabmun_id=${id}`;

  const titleModal =
    userType === 'municipality' || userType === 'citydistrict'
      ? 'Скопируйте сообщение и отправьте его школам муниципалитета'
      : 'Скопируйте сообщение и отправьте его муниципалитетам';

  return (
    <>
      <Main
        text={"Соревнование «Территория безопасности» для учителей и учеников"}
        isDone={isDone}
        items={[plate1?.status!, plate2?.status!, plate3?.status!, plate4?.status!]}
        background='linear-gradient(129.31deg, #B2EB8B -3.31%, #57C7A4 72.51%);
'
      >
        <Wrap>
          <MessagePlate
            status={plate2?.status!}
            number={'II'}
            messageTextToCopy={getTextMessageTwoModal(utm)}
            textPlate={textPlate2}
            nameButton={'Улучшить результат'}
            titlePlate={''}
            titleModal={titleModal}
            taskName="plate2"
          >
            <ContentTwoModal utm={utm} />
          </MessagePlate>

        </Wrap>
      </Main>
    </>
  );
};
